export default __webpack_public_path__ + "static/media/covid19_logo.d2909308.png";